import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import TemporaryAccountWarning from './TemporaryAccountWarning';

const Layout = () => {
  const location = useLocation();

  // Don't show the warning on the lesson viewer page since it's already shown there
  // and don't show it on the claim account page
  const showWarning = !location.pathname.startsWith('/learn/') &&
                      !location.pathname.startsWith('/claim-account');

  return (
    <div className="app-layout">
      <Header />

      {/* Show warning on all pages except lesson viewer and claim account */}
      {showWarning && <TemporaryAccountWarning />}

      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
